import { Board, BoardColuna, WorkCard } from '../../shared/ui/primitivas';
import { TelaAnery } from '../../shared/ui/TelaAnery';
import type { AneryChip, AneryColuna } from '../../shared/ui/tiposDaEsteira';

/** Fronteira da fonte: vira `useQuery` aqui quando `GET /conhecimento` existir. */
const CONHECIMENTO = {
  breadcrumb: 'apoio / conhecimento / bradesco primeiro',
  titulo: 'Base de conhecimento — com citação da fonte',
  subtitulo:
    'A planilha viva de cada especialista vira ativo da empresa. Começa pelos contratos Bradesco, porque é onde a divergência entre Saúde × Seguros e SP × RJ já custou dinheiro.',
  chips: [
    { label: 'curado · ', strong: 'sem dado de paciente' },
    { label: 'resposta sempre com a cláusula citada' },
    { label: 'onboarding 3–6 meses → 2–4 semanas' },
  ] as AneryChip[],
  colunas: [
    {
      nome: 'Bradesco Saúde · SP',
      contagem: 'contrato',
      cards: [
        { titulo: 'Janelas internas', sub: 'dia 3 · 10 · 23' },
        { titulo: 'Kit de prorrogação', sub: '7 documentos · PDF único' },
        {
          titulo: 'Curativo de alto custo',
          sub: 'coberto · cláusula 8.4',
          tone: 'ok',
          flag: { label: 'com fonte', tone: 'ok' },
        },
      ],
    },
    {
      nome: 'Bradesco Seguros · SP',
      contagem: 'contrato',
      cards: [
        {
          titulo: 'Curativo de alto custo',
          sub: 'divergente do Saúde',
          tone: 'warn',
          flag: { label: 'diff', tone: 'warn' },
        },
        { titulo: 'Modalidade', sub: 'AD unitarizada' },
      ],
    },
    {
      nome: 'Bradesco · RJ',
      contagem: 'contrato',
      cards: [
        {
          titulo: 'Tabela de preço',
          sub: 'vigência diferente de SP',
          tone: 'warn',
          flag: { label: 'diff', tone: 'warn' },
        },
        { titulo: 'Regra de pacote', sub: 'zerar linhas em Pacote ID' },
      ],
    },
    {
      nome: 'Regra estruturada',
      contagem: 'trava',
      cards: [
        {
          titulo: 'Tabela de cobertura',
          sub: 'item · pacote · preço · vigência',
          meta: 'extraída uma vez, revisada por gente, virou dado',
          tone: 'ok',
        },
        {
          titulo: 'O RAG explica',
          sub: 'a regra trava',
          meta: 'validador não depende de retrieval',
        },
      ],
    },
  ] as AneryColuna[],
};

export function PaginaDeConhecimento(): React.JSX.Element {
  return (
    <TelaAnery
      breadcrumb={CONHECIMENTO.breadcrumb}
      titulo={CONHECIMENTO.titulo}
      subtitulo={CONHECIMENTO.subtitulo}
      chips={CONHECIMENTO.chips}
    >
      <Board>
        {CONHECIMENTO.colunas.map((col) => (
          <BoardColuna key={col.nome} nome={col.nome} contagem={col.contagem}>
            {col.cards.map((c) => (
              <WorkCard
                key={col.nome + c.titulo}
                titulo={c.titulo}
                sub={c.sub}
                meta={c.meta}
                tone={c.tone}
                flag={c.flag}
              />
            ))}
          </BoardColuna>
        ))}
      </Board>
    </TelaAnery>
  );
}
